export default () => {
  const searchParams = new URLSearchParams(window.location.search.replace('?', ''))
  searchParams.forEach((value, key) => {
    sessionStorage.setItem(`param_${key}`, value)
  })
}
